<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header 
    [currentUser]="currentUser" 
    (logout)="onLogout()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Navigation -->
    <app-staff-nav 
      [isMobileMenuOpen]="isMobileMenuOpen"
      (navigate)="onNavigate($event)"
      (closeMobileMenu)="closeMobileMenu()">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="dashboard-main">
      <div class="main-content">
        <!-- Page Header -->
        <div class="content-header">
          <h1 class="page-title">จัดการเจ้าหน้าที่</h1>
          <p class="page-subtitle">ระบบจัดการข้อมูลเจ้าหน้าที่ของบริษัท</p>
        </div>

        <!-- Mock Data Warning -->
        <ngb-alert 
          *ngIf="showMockDataWarning" 
          type="info" 
          [dismissible]="false"
          class="mb-3">
          <strong>ข้อมูลตัวอย่าง:</strong> 
          ระบบกำลังใช้ข้อมูลตัวอย่างเนื่องจากไม่สามารถเชื่อมต่อ backend API ได้
        </ngb-alert>

        <!-- Filters Section -->
        <div class="filters-section">
          <div class="filters-header">
            <h3>ตัวกรองข้อมูล</h3>
            <button 
              type="button" 
              class="btn btn-outline-secondary btn-sm" 
              (click)="clearFilters()">
              <i class="bi bi-x-circle me-1"></i>ล้างตัวกรอง
            </button>
          </div>
          
          <div class="filters-grid">
            <!-- Search Term -->
            <div class="filter-group">
              <label class="form-label">ค้นหาทั่วไป</label>
              <input 
                type="text" 
                class="form-control" 
                [(ngModel)]="filters.searchTerm" 
                (ngModelChange)="applyFilters()"
                placeholder="ชื่อ, นามสกุล, อีเมล, โทรศัพท์">
            </div>

            <!-- Department -->
            <div class="filter-group">
              <label class="form-label">แผนก</label>
              <select 
                class="form-select" 
                [(ngModel)]="filters.department" 
                (ngModelChange)="applyFilters()">
                <option value="">ทั้งหมด</option>
                <option *ngFor="let dept of departments" [value]="dept">{{ dept }}</option>
              </select>
            </div>

            <!-- Position -->
            <div class="filter-group">
              <label class="form-label">ตำแหน่ง</label>
              <select 
                class="form-select" 
                [(ngModel)]="filters.position" 
                (ngModelChange)="applyFilters()">
                <option value="">ทั้งหมด</option>
                <option *ngFor="let pos of positions" [value]="pos">{{ pos }}</option>
              </select>
            </div>

            <!-- Role -->
            <div class="filter-group">
              <label class="form-label">บทบาท</label>
              <select 
                class="form-select" 
                [(ngModel)]="filters.role" 
                (ngModelChange)="applyFilters()">
                <option value="">ทั้งหมด</option>
                <option *ngFor="let role of roles" [value]="role">
                  {{ role === 'admin' ? 'ผู้ดูแลระบบ' : role === 'manager' ? 'ผู้จัดการ' : 'เจ้าหน้าที่' }}
                </option>
              </select>
            </div>

            <!-- Status -->
            <div class="filter-group">
              <label class="form-label">สถานะ</label>
              <select 
                class="form-select" 
                [(ngModel)]="filters.status" 
                (ngModelChange)="applyFilters()">
                <option value="all">ทั้งหมด</option>
                <option value="active">ใช้งาน</option>
                <option value="inactive">ไม่ใช้งาน</option>
              </select>
            </div>
          </div>
          
          <!-- Action Buttons -->
          <div class="d-flex gap-2 mt-3">
            <button 
              type="button" 
              class="btn btn-success" 
              (click)="createNewStaff()">
              <i class="bi bi-person-plus me-2"></i>เพิ่มเจ้าหน้าที่
            </button>
            <button 
              type="button" 
              class="btn btn-outline-success" 
              (click)="exportToCSV()"
              [disabled]="filteredStaff.length === 0">
              <i class="bi bi-file-earmark-excel me-2"></i>Export CSV
            </button>
            <button 
              type="button" 
              class="btn btn-primary" 
              (click)="loadStaff()">
              <i class="bi bi-arrow-clockwise me-2"></i>รีเฟรชข้อมูล
            </button>
          </div>
        </div>

        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="staff-management-container">
          <div class="loading-state">
            <div class="loading-spinner"></div>
            <p>กำลังโหลดข้อมูลเจ้าหน้าที่...</p>
          </div>
        </div>

        <!-- Staff Table -->
        <div *ngIf="!isLoading" class="table-wrapper">
          <div class="table-responsive">
            <table class="table staff-table">
              <thead>
                <tr>
                  <th class="sortable" (click)="sortBy('firstName')">
                    ชื่อ-นามสกุล {{ getSortIcon('firstName') }}
                  </th>
                  <th class="sortable" (click)="sortBy('email')">
                    อีเมล {{ getSortIcon('email') }}
                  </th>
                  <th class="sortable" (click)="sortBy('phone')">
                    โทรศัพท์ {{ getSortIcon('phone') }}
                  </th>
                  <th class="sortable" (click)="sortBy('department')">
                    แผนก {{ getSortIcon('department') }}
                  </th>
                  <th class="sortable" (click)="sortBy('position')">
                    ตำแหน่ง {{ getSortIcon('position') }}
                  </th>
                  <th class="sortable" (click)="sortBy('role')">
                    บทบาท {{ getSortIcon('role') }}
                  </th>
                  <th class="text-center">สถานะ</th>
                  <th class="text-center">เข้าสู่ระบบล่าสุด</th>
                  <th class="text-center">จัดการ</th>
                </tr>
              </thead>
              <tbody>
                <!-- No Data Row -->
                <tr *ngIf="getCurrentPageStaff().length === 0">
                  <td colspan="9" class="text-center py-4">
                    <div class="text-muted">
                      <i class="bi bi-people"></i>
                      <p class="mb-0">ไม่พบข้อมูลเจ้าหน้าที่</p>
                      <small *ngIf="staff.length === 0">ไม่มีข้อมูลในระบบ</small>
                      <small *ngIf="staff.length > 0 && filteredStaff.length === 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                    </div>
                  </td>
                </tr>

                <!-- Staff Rows -->
                <tr *ngFor="let staffMember of getCurrentPageStaff(); trackBy: trackByStaffId" 
                    class="clickable-row">
                  <!-- Name -->
                  <td class="staff-name">
                    <div class="staff-info">
                      <div class="name">{{ staffMember.firstName }} {{ staffMember.lastName }}</div>
                      <small class="text-muted">ID: {{ staffMember.id }}</small>
                    </div>
                  </td>
                  
                  <!-- Email -->
                  <td>{{ staffMember.email }}</td>
                  
                  <!-- Phone -->
                  <td>{{ staffMember.phone }}</td>
                  
                  <!-- Department -->
                  <td>
                    <span class="badge bg-info">{{ staffMember.department }}</span>
                  </td>
                  
                  <!-- Position -->
                  <td>{{ staffMember.position }}</td>
                  
                  <!-- Role -->
                  <td>
                    <span class="badge" [ngClass]="getRoleBadgeClass(staffMember.role)">
                      {{ staffMember.role === 'admin' ? 'ผู้ดูแลระบบ' : staffMember.role === 'manager' ? 'ผู้จัดการ' : 'เจ้าหน้าที่' }}
                    </span>
                  </td>
                  
                  <!-- Status -->
                  <td class="text-center">
                    <span class="badge" [ngClass]="getStatusClass(staffMember.isActive)">
                      {{ staffMember.isActive ? 'ใช้งาน' : 'ไม่ใช้งาน' }}
                    </span>
                  </td>
                  
                  <!-- Last Login -->
                  <td class="text-center">
                    <small class="text-muted">
                      {{ staffMember.lastLogin || 'ไม่เคยเข้าสู่ระบบ' }}
                    </small>
                  </td>
                  
                  <!-- Actions -->
                  <td class="text-center">
                    <div class="action-buttons">
                      <button 
                        type="button" 
                        class="btn btn-sm btn-primary me-1" 
                        (click)="editStaff(staffMember); $event.stopPropagation()"
                        title="แก้ไข">
                        <i class="bi bi-pencil"></i>
                      </button>
                      <button 
                        type="button" 
                        class="btn btn-sm" 
                        [class.btn-success]="!staffMember.isActive"
                        [class.btn-secondary]="staffMember.isActive"
                        (click)="toggleStaffStatus(staffMember); $event.stopPropagation()"
                        [title]="staffMember.isActive ? 'ปิดใช้งาน' : 'เปิดใช้งาน'">
                        <i class="bi" [class.bi-check-circle]="!staffMember.isActive" [class.bi-x-circle]="staffMember.isActive"></i>
                      </button>
                      <button 
                        type="button" 
                        class="btn btn-sm btn-danger ms-1" 
                        (click)="deleteStaff(staffMember); $event.stopPropagation()"
                        title="ลบ">
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Pagination -->
        <div *ngIf="!isLoading && filteredStaff.length > 0" class="d-flex justify-content-between align-items-center mt-3">
          <div class="d-flex align-items-center gap-3">
            <div class="text-muted">
              แสดงผล {{ ((page - 1) * pageSize) + 1 }} - {{ min(page * pageSize, collectionSize) }} 
              จาก {{ collectionSize }} รายการ
            </div>
            <div class="d-flex align-items-center gap-2">
              <span class="text-muted small">แสดงผล:</span>
              <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize"
                (ngModelChange)="changePageSize(pageSize)" aria-label="จำนวนรายการต่อหน้า">
                <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} รายการ</option>
              </select>
            </div>
          </div>
          <ngb-pagination 
            [(page)]="page" 
            [pageSize]="pageSize" 
            [collectionSize]="collectionSize"
            [maxSize]="5"
            [rotate]="true"
            [boundaryLinks]="true"
            [size]="'sm'">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
